import dayjs from 'dayjs';

import * as analyticsApi from '@/api/analytics';

async function processSignInEvent(user) {
  const tokenResult = await user?.getIdTokenResult();

  if (!tokenResult) {
    return;
  }

  const savedUserTokenExpTime = localStorage.getItem('USER_TOKEN_EXP_TIME');
  const userTokenExpTime = tokenResult?.claims.exp;

  if (tokenResult && userTokenExpTime && +savedUserTokenExpTime !== userTokenExpTime) {
    const eventPayload = {
      userId: tokenResult.claims.user_id,
      provider: tokenResult.signInProvider,
      createdAt: dayjs().utc().unix(),
    };

    await analyticsApi.createEvent({ event: 'sign_in', payload: eventPayload });
    localStorage.setItem('USER_TOKEN_EXP_TIME', userTokenExpTime);
  }
}

export default processSignInEvent;
